import manageError from 'utils/logging/manageError';

/**
 * Set the user id for the session
 * @see https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/setuserid/
 *
 * @param userId
 */
const setUserId = (userId: string | null) => {
  if (process.env.REACT_APP_NEW_RELIC === 'true' && typeof window.newrelic !== 'undefined') {
    try {
      newrelic.setUserId(userId);
    } catch (error) {
      // do not crash because of this
      manageError(error, { userId: userId ?? 'null' });
    }
  } else {
    console.info('Set user id :', userId);
  }
};

export default setUserId;
